import _objectSpread from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { Action } from './Action';
import { ActionStatus } from './ActionStatus';
import { buildActionType } from './buildActionType';
import { FailedNotification, SuccessNotification } from './Notification';
import { NotificationType } from './NotificationType';
// import { PROVIDER_COURSES_GET_MANY } from '../new/course';
import { BUSY_INDICATOR, CHANGE_ORDER, LOGOUT, NOTIFICATION, PRODUCT_S3, PRODUCT_VIDEO_DELETE, PRODUCT_VIDEOS_GET_MANY, PRODUCTS_GET_MANY, PRODUCTS_SECTIONS_GET_MANY, PROVIDER_DELETE_BREAKS, PROVIDER_GET_ONETIME } from '../types';
const conditionalActions = _ref => {
  let {
    dispatch,
    action,
    response
  } = _ref;
  let serviceType = {};
  // if (response.type && response.type === 'Y') {
  //   serviceType = PROVIDER_COURSES_GET_MANY;
  // }
  // if (response.type && response.type === 'E') {
  //   serviceType = PROVIDER_EVENTS_GET_MANY;
  // }
  if (response.type && response.type === 'N') {
    serviceType = PROVIDER_GET_ONETIME;
  }
  if (response.type && response.type === 'P') {
    serviceType = PRODUCTS_GET_MANY;
  }
  switch (action) {
    case CHANGE_ORDER:
      return dispatch({
        type: buildActionType(serviceType, ActionStatus.UPDATE),
        newArr: response.data
      });
    case PRODUCT_S3:
      return dispatch({
        type: buildActionType(PRODUCTS_SECTIONS_GET_MANY, ActionStatus.INCREASE),
        index: response.data.sectionIndex
      });
    case PRODUCT_VIDEO_DELETE:
      return dispatch({
        type: buildActionType(PRODUCTS_SECTIONS_GET_MANY, ActionStatus.DECREASE),
        index: response.data.sectionIndex
      });
    default:
      return null;
  }
};
const customMessageActions = _ref2 => {
  let {
    dispatch,
    action,
    customMessage,
    response
  } = _ref2;
  if (action === PRODUCT_VIDEOS_GET_MANY && !response.result) {
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: customMessage,
        variant: NotificationType.Warning
      }
    });
  } else {
    if (action === PRODUCT_VIDEOS_GET_MANY) {
      dispatch({
        type: NOTIFICATION,
        payload: {
          message: SuccessNotification["".concat(action.action)],
          variant: NotificationType.Success
        }
      });
    } else {
      dispatch({
        type: NOTIFICATION,
        payload: {
          message: customMessage,
          variant: NotificationType.Success
        }
      });
    }
  }
};
const executeApiCall = function (apiCallExecution, action) {
  let silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let customMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let noMessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return async dispatch => {
    const dispatchActions = {};
    const addDispatch = function (action) {
      let status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const type = buildActionType(action, status);
      dispatchActions[type] = dispatch(_objectSpread({
        type
      }, props));
    };
    if (!silent) {
      addDispatch(action, ActionStatus.START);
      addDispatch(BUSY_INDICATOR, ActionStatus.START);
    }
    const response = await apiCallExecution;
    if (response.success) {
      addDispatch(action, ActionStatus.DONE, {
        payload: response.data,
        report: response.report
      });
      conditionalActions({
        dispatch,
        response,
        action
      });
      if (customMessage) {
        customMessageActions({
          dispatch,
          action,
          customMessage,
          response
        });
      } else if (!noMessage) {
        addDispatch(NOTIFICATION, '', {
          payload: {
            message: response.message || SuccessNotification["".concat(action.action)],
            variant: NotificationType.Success
          }
        });
      }
    } else {
      addDispatch(action, ActionStatus.FAILED);
      if (action !== PROVIDER_DELETE_BREAKS) {
        if (!noMessage) {
          var _response$errors$;
          addDispatch(NOTIFICATION, '', {
            payload: {
              message: ((_response$errors$ = response.errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.message) || FailedNotification["".concat(action.action)],
              variant: NotificationType.Error
            }
          });
        }
      }
    }
    if (response.status === 401) {
      addDispatch(LOGOUT);
    }
    if (!silent) {
      addDispatch(BUSY_INDICATOR, ActionStatus.DONE);
    }
    return dispatchActions;
  };
};
const dispatchApiCall = (action, dispatch) => (err, d, res) => {
  if (!res || !res.body) {
    dispatch({
      type: buildActionType(action, ActionStatus.FAILED)
    });
  } else {
    const {
      body: {
        data,
        options
      }
    } = res;
    if (options) {
      dispatch({
        type: buildActionType({
          entity: action.entity,
          action: Action.SET_OPTIONS
        }),
        payload: options
      });
    }
    if (data) {
      dispatch({
        type: buildActionType(action, ActionStatus.DONE),
        payload: data
      });
    } else {
      dispatch({
        type: buildActionType(action, ActionStatus.FAILED)
      });
    }
  }
};
export { executeApiCall, dispatchApiCall };